module.exports = __webpack_public_path__ + "static/media/keramaian.9209d5a6.png";